import { render, staticRenderFns } from "./BaseTableReportHistoryTable.vue?vue&type=template&id=4e6428d2"
import script from "./BaseTableReportHistoryTable.vue?vue&type=script&lang=js"
export * from "./BaseTableReportHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports